import React from "react"
import styled from "styled-components"
import {Btn, SecondaryBtn} from "../Welcome/WelcomeBanner";
import {BigCenter} from "../shared/mix";
import {Link} from "react-router-dom";
import ReactGA from "react-ga";

const CTA = () => {
    const handleClick = () => {
        ReactGA.event({
            category: 'CTA-click',
            action: "info-more"
        });
    }

    return (
        <BigCenter>
            <Poster>
                <PosterLabel>Zaujal jsem Vás?</PosterLabel>
                <PosterTitle>Pojďme spolupracovat na&nbsp;Vašem dalším projektu.</PosterTitle>
                <PosterButtons>
                    <Link to="/kontakt/"><Btn onClick={handleClick}>Kontakt</Btn></Link>
                    <Link to="/reference/"><SecondaryDark onClick={handleClick}>Reference</SecondaryDark></Link>
                </PosterButtons>
            </Poster>
        </BigCenter>
    )
}

export default CTA

const Poster = styled.div`
  background: rgba(25, 25, 25, 1);
  color: #fff;
  border-radius: 0.6em;
  padding: 4em 3em;
  margin-top: 10em;
  text-align: center;

  @media (min-width: 740px) {
    padding: 5em 6em;
  }
`

const PosterLabel = styled.div`
  font-size: 0.78em;
  font-weight: 400;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.35;
  margin-bottom: 1.5em;
`

const PosterTitle = styled.h2`
  font-weight: 800;
  font-size: 2em;
  line-height: 1.25;
  margin: 0 auto 1.5em;
  max-width: 14em;
  letter-spacing: -0.02em;

  @media (min-width: 740px) {
    font-size: 2.8em;
  }
`

const PosterButtons = styled.div`
  display: flex;
  gap: 0.6em;
  justify-content: center;

  a {
    text-decoration: none;
  }
`

const SecondaryDark = styled(SecondaryBtn)`
  background: rgba(255, 255, 255, 0.12);
  color: #fff;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }
`
